module.exports = __webpack_public_path__ + "img/j.0584fec5.png";